// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"SingularKeyCell-primaryButton-1YK-pA","singularKey":"SingularKeyCell-singularKey-1I2oWI"};